/**
 * Permisos de rol por ruta — alineado con DASHBOARD_ROUTE_REGISTRY (ítem 21).
 */
import { DASHBOARD_ROUTE_REGISTRY } from '@/soluqr/tiers/registry';

/** path → permiso mínimo del rol de panel (mismos valores que PERM en dashboardPermissions). */
export const DASHBOARD_ROUTE_PERMISSION_BY_PATH = Object.freeze({
  '/dashboard': 'dashboard',
  '/dashboard/config': 'config',
  '/dashboard/design': 'config',
  '/dashboard/products': 'products',
  '/dashboard/promos': 'promos',
  '/dashboard/customers': 'customers',
  '/dashboard/orders': 'orders',
  '/dashboard/orders/kitchen': 'orders',
  '/dashboard/delivery': 'orders',
  '/dashboard/solugo': 'orders',
  '/dashboard/own-delivery': 'orders',
  '/dashboard/solugo/admin': 'orders',
  '/dashboard/orders-live': 'orders_live',
  '/dashboard/kds': 'kds',
  '/dashboard/pos': 'pos',
  '/dashboard/notifications': 'notifications',
  '/dashboard/qr': 'qr',
  '/dashboard/membership': 'membership',
  '/dashboard/analytics': 'analytics',
  '/dashboard/reports': 'analytics',
  '/dashboard/tables': 'tables',
  '/dashboard/support': 'support',
  '/dashboard/assistant-training': 'assistant_training',
  '/dashboard/benefits-club': 'benefits',
  '/dashboard/team': 'team_manage',
  '/dashboard/broadcast': 'broadcast',
  '/dashboard/locations': 'config',
});

/** Prefijo más largo primero → permiso (para permissionForPath). */
export const DASHBOARD_ROUTE_PERMISSION_RULES = Object.entries(DASHBOARD_ROUTE_PERMISSION_BY_PATH)
  .map(([path, permission]) => [path, permission])
  .sort((a, b) => b[0].length - a[0].length);

/**
 * Valida que cada ruta del registry tenga permiso de rol definido.
 * @returns {string[]} paths sin permiso
 */
export function dashboardRegistryPathsMissingPermission() {
  const registryPaths = DASHBOARD_ROUTE_REGISTRY.map((r) => r.path);
  return registryPaths.filter((p) => !DASHBOARD_ROUTE_PERMISSION_BY_PATH[p]);
}
